export default "__VITE_ASSET__HfehuJ7P__"